import React from "react";
import { Page } from "../../components/page/page";
import styles from "./intuitive-healing.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIntuitiveHealing } from "../../store/stateSlice";

const options = [
  {
    value: "I often comfort or heal people",
    icon: "🤩",
  },
  {
    value: "I can intuitively find the right words",
    icon: "😌",
  },
  {
    value: "I don't rely on intuition",
    icon: "🙂",
  },
  {
    value: "Not sure",
    icon: "🤔",
  },
];

const IntuitiveHealingPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="Do you find yourself instinctively knowing how to comfort or heal others, whether emotionally or physically?"
      hideContinueButton={true}
      currentStep={12}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../symbols"
              onClick={() => dispatch(setIntuitiveHealing(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { IntuitiveHealingPage };
